import { Link } from "react-router-dom";
import type { ArticleItem } from "@/mocks/articles";
import { formatDate } from "@/lib/content";

interface NewsBriefProps {
  items: ArticleItem[];
}

export default function NewsBrief({ items }: NewsBriefProps) {
  return (
    <aside className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-black text-foreground-950 md:text-lg">
          <i className="ri-flashlight-line text-primary-600"></i>
          资讯快览
        </h2>
        <Link
          to="/category/movie"
          className="flex items-center gap-0.5 whitespace-nowrap text-xs font-medium text-primary-700 hover:text-primary-800"
        >
          更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <ul className="flex flex-1 flex-col divide-y divide-background-200">
        {items.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex gap-3 py-3 first:pt-0 last:pb-0"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  index < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-300 text-foreground-700"
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0">
                <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <span className="mt-1 block text-[11px] text-foreground-500">
                  {formatDate(item.date)}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}